import { Injectable } from '@angular/core';
import { HybseConfig } from '../../config/hybse.config';


@Injectable()
export class ApiurlsService {

  constructor(public config: HybseConfig) { }

  /* Get Session Key */
  getSessionkeyUrl: string = this.config.apiURL + 'getSessionkey';


  /* User Api Urls */
  // createUserUrl:string = this.config.apiURL+'createUser';
  createUserAdminUrl: string = this.config.apiURL + 'adminRegister';
  // createUserInvestorUrl:string = this.config.apiURL+'investorRegister';
  createUserInvestorUrl: string = this.config.apiURL + 'createInvestorByAdmin';
  createUserIssuerUrl: string = this.config.apiURL + 'createIssuerByAdmin';
  adminListUrl: string = this.config.apiURL + 'adminList';
  deleteUserUrl: string = this.config.apiURL + 'deleteUser';
  getUserDataUrl: string = this.config.apiURL + 'userDetailedView';
  // updateUserUrl:string = this.config.apiURL+'updateUser';
  updateUserUrl: string = this.config.apiURL + 'updateUser';
  updateAdminUrl: string = this.config.apiURL + 'updateAdmin';
  updateInvestorUrl: string = this.config.apiURL + 'updateInvestor';
  viewWalletUrl: string = this.config.apiURL + 'userWalletDetails';
  userActiveUrl: string = this.config.apiURL + 'activeUser';
  userDetailsUrl: string = this.config.apiURL + 'userDetails';
  detailedUserInfo: string = this.config.apiURL + 'detailedUserInfo';
  companyDetail: string = this.config.apiURL + 'companyDetail';
  userLoginDetailsUrl: string = this.config.apiURL + 'userLoginDetails';

  /* stock list */
  demoStockListUrl: string = this.config.apiURL + 'demoStockList';


  /* Login Api Urls */
  // loginUrl: string = this.config.apiURL + 'adminLogin';
  loginUrl: string = this.config.authURL + 'adminLogin';

  /*  dashboard */

  getUserOverview = this.config.apiURL + 'getUserOverview';

  /*  User details */
  userDemoBuyorderList = this.config.apiURL + 'userDemoBuyorderList';
  userDemoSellorderList = this.config.apiURL + 'userDemoSellorderList';
  userBuyorderList = this.config.apiURL + 'userBuyorderList';
  userSellorderList = this.config.apiURL + 'userSellorderList';
  demoWalletsDetails = this.config.apiURL + 'userDemoWalletDetails';
  updateUserInfoByAdmin = this.config.apiURL + 'updateUserInfoByAdmin';
  tradingHistory = this.config.apiURL + 'tradingHistory';
  iboSellorderListUrl = this.config.apiURL + 'iboSellorderList';
  iboBuyListUrl = this.config.apiURL + 'iboBuyList';
  iboCommissionListUrl = this.config.apiURL + 'iboCommissionList';




  /* News Api Urls */
  compListUrl: string = this.config.apiURL + 'listExchangeNews';
  newsCreateUrl: string = this.config.apiURL + 'createNews';
  compDetailUrl: string = this.config.apiURL + 'getNews';
  companyUpdateUrl: string = this.config.apiURL + 'editNews';
  companyDeleteUrl: string = this.config.apiURL + 'deleteNews';
  companyActiveUrl: string = this.config.apiURL + 'publishNews';

  /* Company management Api Urls */
  addCompanyManagementUrl: string = this.config.apiURL + 'addCompanyManagement';
  deleteCompanyManagementUrl: string = this.config.apiURL + 'deleteCompanyManagement';
  companyManagementUpdateUrl: string = this.config.apiURL + 'companyManagementUpdate';

  addCompanyDocumentsUrl: string = this.config.apiURL + 'addCompanyDocuments';
  updateCompanyDocumentUrl: string = this.config.apiURL + 'updateCompanyDocument';
  deleteCompanyDocumentsUrl: string = this.config.apiURL + 'deleteCompanyDocuments';

  /* Page Category */
  pageCatListUrl: string = this.config.apiURL + 'listContentCategory';
  pageCatCreateUrl: string = this.config.apiURL + 'createContentCategory';
  pageCatUpdateUrl: string = this.config.apiURL + 'updateContentCategory';
  pageCatDeleteUrl: string = this.config.apiURL + 'deleteContentCategory';
  getpageCatUrl: string = this.config.apiURL + 'getContentCategory';

  /* Page  */
  pageListUrl: string = this.config.apiURL + 'listContent';
  pageCreateUrl: string = this.config.apiURL + 'createContent';
  pageUpdateUrl: string = this.config.apiURL + 'updateContent';
  pageDeleteUrl: string = this.config.apiURL + 'deleteContent';
  getpageUrl: string = this.config.apiURL + 'getContent';


  /* Menu  */
  createMenuUrl: string = this.config.apiURL + 'createMenu';
  updateMenuUrl: string = this.config.apiURL + 'updateMenu';
  deleteMenuUrl: string = this.config.apiURL + 'deleteMenu';
  listAllMenuUrl: string = this.config.apiURL + 'listAllMenu';


  /* Menu  Items */
  createMenuItems: string = this.config.apiURL + 'createMenuItems';
  updateMenuItemsUrl: string = this.config.apiURL + 'updateMenuItems';
  deleteMenuItemsUrl: string = this.config.apiURL + 'deleteMenuItems';
  listAllMenuItemUrl: string = this.config.apiURL + 'orderMenuHierarchy';
  listMenuItemUrl: string = this.config.apiURL + 'getMenuItemsByName';



  /* Symbols */
  createSymbolUrl: string = this.config.apiURL + 'createSymbol';
  updateSymbolUrl: string = this.config.apiURL + 'updateSymbol';
  deleteSymbolUrl: string = this.config.apiURL + 'deleteSymbol';
  primarySymbolUrl: string = this.config.apiURL + 'primarySymbol';

  /* Markets */
  createMarketUrl: string = this.config.apiURL + 'createMarket';
  updateMarketUrl: string = this.config.apiURL + 'updateMarket';
  deleteMarketUrl: string = this.config.apiURL + 'deleteMarket';
  marketListUrl: string = this.config.apiURL + 'marketList';
  marketDetailUrl: string = this.config.apiURL + 'detailedMarket';


  /* Activities Log */
  activityLogsUrl: string = this.config.apiURL + 'userActivityDetails';
  activityCodeUrl: string = this.config.apiURL + 'activityCode';
  activityDetailsUrl: string = this.config.apiURL + 'activityDetails';
  commissionLogListUrl = this.config.apiURL + 'commissionLogList';
  orderMatchesListUrl = this.config.apiURL + 'orderMatchesList';

  /* demo Activities log */
  demoCommissionLogListUrl: string = this.config.apiURL + 'demoCommissionLogList';
  demoOrderMatchesListUrl = this.config.apiURL + 'demoOrderMatchesList';


  /* Locale */
  createLocaleUrl: string = this.config.apiURL + 'createLocale';
  updateLocaleUrl: string = this.config.apiURL + 'updateLocale';
  deleteLocaleUrl: string = this.config.apiURL + 'deleteLocale';
  listLocaleUrl: string = this.config.apiURL + 'getLocale';
  getLocaleByIdUrl: string = this.config.apiURL + 'getLocaleone';

  /* Translation */
  createTranslationUrl: string = this.config.apiURL + 'createTranslation';
  updateTranslationUrl: string = this.config.apiURL + 'updateTranslation';
  deleteTranslationUrl: string = this.config.apiURL + 'deleteTranslation';
  listTranslationUrl: string = this.config.apiURL + 'translationList';
  getTranslationByIdUrl: string = this.config.apiURL + 'getTranslationOne';

  /* Mail Template */
  createMessageTemplateUrl: string = this.config.apiURL + 'createMessageTemplate';
  updateMessageTemplateUrl: string = this.config.apiURL + 'updateMessageTemplate';
  deleteMessageTemplateUrl: string = this.config.apiURL + 'deleteMessageTemplate';
  listMessageTemplateUrl: string = this.config.apiURL + 'listMessageTemplate';
  // getTemplateByIdUrl: string = this.config.apiURL + 'detailedMessageTemplate';
  getTemplateByIdUrl: string = this.config.apiURL + 'messageTemplateByIdMessageTemplate';

  /* IBO  */
  createIBOUrl: string = this.config.apiURL + 'createIBOMarket';
  updateIBOUrl: string = this.config.apiURL + 'updateIBOMarket';
  deleteIBOUrl: string = this.config.apiURL + 'deleteIBO';
  listIBOUrl: string = this.config.apiURL + 'iBOList';
  getIBObyIdUrl: string = this.config.apiURL + 'iBODetailedList';

  /* DemoCompany  */
  createDemoCompanyUrl: string = this.config.apiURL + 'createDemoCompany';
  updateDemoCompanyUrl: string = this.config.apiURL + 'updateDemoCompany';
  deleteDemoCompanyUrl: string = this.config.apiURL + 'deleteDemoCompany';
  listDemoCompanyUrl: string = this.config.apiURL + 'demoCompanyList';
  getDemoCompanybyIdUrl: string = this.config.apiURL + 'companyDetail';

  /* DemoSymbol  */
  createDemoSymbolUrl: string = this.config.apiURL + 'democreateSymbol';
  updateDemoSymbolUrl: string = this.config.apiURL + 'demoupdateSymbol';
  deleteDemoSymbolUrl: string = this.config.apiURL + 'demodeleteSymbol';
  listDemoSymbolUrl: string = this.config.apiURL + 'listDemoSymbol';
  primaryDemoSymbolUrl: string = this.config.apiURL + 'primaryDemoSymbol';

  /* DemoMarket  */
  demoMarketListUrl: string = this.config.apiURL + 'demoMarketList';
  marketDemoDetailUrl: string = this.config.apiURL + 'detailedDemoMarket';

  /* Invitation */
  createInvitationUrl: string = this.config.apiURL + 'inviteUser';
  listInvitationUrl: string = this.config.apiURL + 'invitationList';

  /* KYC */
  KycListUrl: string = this.config.apiURL + 'kycList';
  approveKycUrl: string = this.config.apiURL + 'kycVerify';
  rejectKycUrl: string = this.config.apiURL + 'kycReject';

  /* Partner */
  partnerTradeListUrl: string = this.config.apiURL + 'partnerTradeList';
  partnerTxnLogUrl: string = this.config.apiURL + 'partnerTxnLog';

  /* Log Out Api Urls */
  logOutUrl: string = this.config.apiURL + 'Logout';

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/services/api-urls/apiurls.service.ts